



































































































































































































































































































































































































































































































































































































































































































































































































































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import * as I from '@/interfaces';
import { DataStore, DataItem } from '@/utils';

import exceljs from 'exceljs';
import moment from 'moment';
import { title } from 'process';

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  singleSelect: boolean;
  callback: () => Promise<void>;

  constructor() {
    this.singleSelect = true;
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

class BatchDialogState {
  show: boolean;
  title: string;
  groupFlag: string;
  doorFlag: string;
  selectGroup: string;
  selectDoor: string;
  companyCode: I.CodeData;
  deptCodeA: I.CodeData;
  deptCodeB: I.CodeData;
  dutyCodeA: I.CodeData;
  listCompanyCode: I.CodeData[];
  userStatus: I.CodeData;
  listDeptCodeA: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listDutyCodeA: I.CodeData[];
  listUserStatus: I.CodeData[];
  listDoor: I.DoorData[];
  listGroup: I.DoorData[];
  selected: I.CodeData;
  periodFrom!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  periodTo!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  groupzoneCode: number;
  doorzoneCode: number;
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.groupFlag = 'I';
    this.doorFlag = 'I';
    this.selectGroup = '';
    this.selectDoor = '';
    this.selected = { code: '', name: '', dataType: '', etc: '' };
    this.companyCode = { code: '', name: '', dataType: '', etc: '' };
    this.deptCodeA = { code: '', name: '', dataType: '', etc: '' };
    this.deptCodeB = { code: '', name: '', dataType: '', etc: '' };
    this.dutyCodeA = { code: '', name: '', dataType: '', etc: '' };
    this.userStatus = { code: '', name: '', dataType: '', etc: '' };
    this.listCompanyCode = [];
    this.listDeptCodeA = [];
    this.listDeptCodeB = [];
    this.listDutyCodeA = [];
    this.listUserStatus = [];
    this.listDoor = [];
    this.listGroup = [];
    this.groupzoneCode = 1;
    this.doorzoneCode = 1;
    this.callback = async () => {};
  }
}

class State {
  searchWord: string;
  isSearchGrid: boolean;
  isEscort: boolean;
  pageNum: number;
  selected: unknown[];

  timeRules = (v: string) =>
    /^(2[0-9][0-9][0-9])-(0[0-9]|1[0-2])-(0[0-9]|1[0-9]|2[0-9]|3[0-1])$/.test(v);

  listCompanyCode: I.CodeData[];
  listDeptCodeA: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listDutyCodeA: I.CodeData[];
  listUserType: I.CodeData[];
  listUserStatus: I.CodeData[];
  listDoor: I.DoorData[];
  listGroup: I.DoorData[];

  periodFromOne!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  periodFromTwo!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  periodToOne!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  periodToTwo!: Date; // = new Date('2050-12-31').toISOString().substr(0, 10);
  constructor() {
    this.searchWord = '';
    this.isSearchGrid = true;
    this.isEscort = false;
    this.pageNum = 0;
    this.listCompanyCode = [];
    this.listDeptCodeA = [];
    this.listDeptCodeB = [];
    this.listDutyCodeA = [];
    this.listUserType = [];
    this.listUserStatus = [];
    this.listDoor = [];
    this.listGroup = [];
    this.selected = [];
  }
  get cleared() {
    return (
      [
        this.listCompanyCode,
        this.listDeptCodeA,
        this.listDeptCodeB,
        this.listUserStatus,
        this.listGroup,
        this.listDoor,
        this.listUserType
      ]
        .map(x => x.length > 0)
        .filter(x => x === true).length === 0
    );
  }
}

@Component
export default class Search extends Mixins(AxPage) {
  state = new State();
  dialogState = new DialogState();
  batchDialogState = new BatchDialogState();

  tableParam = new DataStore<I.User>({
    headers: {
      empno: '사원번호',
      name: '이름',
      uid: '카드번호',
      companyName: '회사',
      deptNameA: '사업장',
      deptNameB: '부서',
      dutyNameA: '직급',
      periodTo: '종료일자',
      telNo: '전화번호',
      notUseDay: '미사용',
      userStatusName: '상태',
      cardType: '유형'
    }
  });
  showPageCount = 5;
  beginDateMenu1 = false;
  beginDateMenu2 = false;
  beginDateMenu3 = false;
  beginDateMenu4 = false;
  isOpenAdvSearch = false;
  isGridOnOff = false;

  selected = [
    { select: false },
    { select: false },
    { select: false },
    { select: false },
    { select: false },
    { select: false },
    { select: false },
    { select: false }
  ];

  pageInfo?: I.UserSearchPageInfo;
  searchData = {} as I.UserSearchResult;
  dataItem!: DataItem<unknown, State>;

  async prepare() {
    const baseData = await this.getBaseData();
    if (baseData) {
      this.pageInfo = baseData;
      this.state.isSearchGrid = false;
      this.state.searchWord = 'TODAY';
      this.onSearchClicked();
      this.state.searchWord = '';
      console.log('baseData', baseData);
    }
  }

  async onExportExcel() {
    if (!this.tableParam.items) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    console.log(this.tableParam);

    const colNames = (n: number) => {
      const ordA = 'A'.charCodeAt(0);
      const ordZ = 'Z'.charCodeAt(0);
      const len = ordZ - ordA + 1;

      let s = '';
      while (n >= 0) {
        s = String.fromCharCode((n % len) + ordA) + s;
        n = Math.floor(n / len) - 1;
      }
      return s;
    };

    moment.locale('ko');
    const momentTime = moment(Date.now());
    const outputPrefix = `사용자조회_`;

    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
    const headers = this.tableParam.getHeaders();
    const headerKeys = Object.keys(headers);
    if (!headers) {
      await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
      return;
    }

    // 헤더 작성 (식수 조회 [사원별] 등등..)
    const headerSize = Object.keys(headers).length;
    worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
    worksheet.getCell('A1').value = `사용자 조회`;
    worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    let row = 2;

    // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
    // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
    //this.dataItem.description.forEach(x => (worksheet.getCell(`A${row++}`).value = x));

    // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다
    worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

    worksheet.insertRow(row, ['No.', ...Object.values(headers)], 'i');
    const headerRow = row++;

    // 아이템 필터. Header에 들어간 item만 뽑는다
    /*const items = this.tableParam.getItems().map((x, idx) => {
      const arr: unknown[] = [];
      headerKeys.forEach(y => arr.push((x as { [key: string]: unknown })[y]));
      return [idx + 1, ...arr];
    });
    worksheet.insertRows(row, items, 'i');*/

    const items = this.searchData.listUser.map((x, idx) => {
      const arr: unknown[] = [];
      headerKeys.forEach(y => arr.push((x as { [key: string]: unknown })[y]));
      return [idx + 1, ...arr];
    });
    worksheet.insertRows(row, items, 'i');

    // 헤더 라인에 음영 및 테두리 넣기
    worksheet.getRow(headerRow).eachCell(cell => {
      cell.style = {};
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFBFBFBF' },
        bgColor: { argb: 'FFFFFF00' }
      };

      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    // 엑셀 파일을 저장한다
    const xls64 = await workbook.xlsx.writeBuffer();
    const a = document.createElement('a');
    const data = new Blob([xls64], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = URL.createObjectURL(data);
    a.href = url;
    a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  async getBaseData() {
    const result = await this.API.call.user.userSearchPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async getSearchDetail(param: I.PacketUserSearchDetail) {
    console.log('search');
    console.log(param);
    const result = await this.API.call.user.searchDetail(param);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async getSearch(param: I.PacketUserSearchDetail) {
    console.log('search');
    console.log(param);
    const result = await this.API.call.user.search(param);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async requestSearch() {
    const {
      searchWord,
      isSearchGrid,
      isEscort,
      pageNum,
      listCompanyCode,
      listDeptCodeA,
      listDeptCodeB,
      listDutyCodeA,
      listUserType,
      listUserStatus,
      listDoor,
      listGroup
    } = this.state;
    const searchData = await this.getSearch({
      searchWord,
      isSearchGrid,
      isEscort,
      pageNum,
      listCompanyCode,
      listDeptCodeB,
      listDeptCodeA,
      listUserType,
      listUserStatus,
      listDutyCodeA,
      listDoor,
      listGroup
    });
    if (searchData) {
      this.searchData = searchData;
      this.tableParam.items = searchData.listUser;
      console.log(searchData);
    }
  }

  async requestSearchDetail() {
    const {
      searchWord,
      isSearchGrid,
      isEscort,
      pageNum,
      listCompanyCode,
      listDeptCodeA,
      listDeptCodeB,
      listDutyCodeA,
      listUserType,
      listUserStatus,
      listDoor,
      listGroup
    } = this.state;
    const searchData = await this.getSearchDetail({
      searchWord,
      isSearchGrid,
      isEscort,
      pageNum,
      listCompanyCode,
      listDeptCodeB,
      listDeptCodeA,
      listUserType,
      listUserStatus,
      listDutyCodeA,
      listDoor,
      listGroup
    });
    if (searchData) {
      this.searchData = searchData;
      this.tableParam.items = searchData.listUser;
      console.log(searchData);
    }
  }

  onToggleAdvSearch() {
    this.isOpenAdvSearch = !this.isOpenAdvSearch;
  }

  ClickGridUser(i: number) {
    console.log('click');
    const user = this.searchData.listUser[i];
    if (!user) return;
    const list = this.state.selected as I.User[];
    const idx = list.findIndex(x => x.userId === user.userId);
    if (idx > -1) list.splice(idx, 1);
    else this.state.selected.push(user);
  }

  gridSelected(i: number) {
    console.log('gridselected');
    if (this.searchData.listUser.length === 0) return false;
    const user = this.searchData.listUser[i];
    if (!user) return false;
    const idx = (this.state.selected as I.User[]).findIndex(x => x.userId === user.userId);
    return idx > -1;
  }

  ClickUserEditMulti() {
    /* if (!this.pageInfo) return;
    this.OnClearClicked();
    const list = this.getZoneList();
    if (list) {
      this.batchDialogState.groupzoneCode = list[0].code;
      this.batchDialogState.doorzoneCode = list[0].code;
    }

    this.batchDialogState.listCompanyCode = this.pageInfo.listCompanyCode;
    const listDepta = this.pageInfo.listDeptCodeA;
    console.log('deptcodea', listDepta);
    this.batchDialogState.listDeptCodeA = listDepta;
    this.batchDialogState.listDeptCodeB = this.pageInfo.listDeptCodeB;
    this.batchDialogState.listDutyCodeA = this.pageInfo.listDutyCodeA;
    this.batchDialogState.listUserStatus = this.pageInfo.listUserStatus;
    this.batchDialogState.show = true;
    this.batchDialogState.title = '사용자 정보 일괄 수정';
    console.log('batchDiglogState', this.batchDialogState);
    console.log('pageInfo', this.pageInfo);*/
    type IssueCardDialogParams = { param: I.DataParam };
    const dialogParams = new I.DialogParam<IssueCardDialogParams>('AxBatchUpdateDialog', {
      param: {
        items: [],
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected[0] as batchDialogState;
          if (!selected) return;
          this.batchDialogState = selected;
          this.OnClickBatchUpdate();
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickUserEdit() {
    console.log('clickUserEdit');
    const callback = async (user: I.User) => {
      console.log('edit callback');
      console.log(user);
      this.closeDialog();
      // this.CloseDialog({
      //   type: 'AxUserRegisterDialog',
      //   props: {
      //     callback,
      //     user
      //   }
      // });
      const f = this.searchData.listUser.find(x => x.userId === user.userId);
      console.log(f);
      if (f) {
        const idx = this.searchData.listUser.indexOf(f);
        console.log(idx);
        this.searchData.listUser.splice(idx, 1, user);
      }
    };
    const listUser = this.state.selected as I.User[];
    if (!listUser || listUser.length === 0) return;

    const user = listUser[0];

    this.showDialog({
      type: 'AxUserRegisterDialog',
      props: {
        callback,
        user
      }
    });
  }

  ClickUserEditEach(i: number) {
    const callback = async (user: I.User) => {
      this.closeDialog();
      const f = this.searchData.listUser.find(x => x.userId === user.userId);
      if (f) {
        const idx = this.searchData.listUser.indexOf(f);
        this.searchData.listUser.splice(idx, 1, user);
      }
    };

    const user = this.searchData.listUser[i];
    console.log('select user=');
    console.log(this.searchData.listUser[i]);

    if (!user) return;
    console.log('select user 1');
    //const list = this.state.selected as I.User[];

    //const listUser = this.state.selected as I.User[];
    //if (!listUser || listUser.length === 0) return;

    //const user = listUser[0];
    // 선택된 첫번째 사용자 정보를 이용한다.
    //    console.log('edit user');
    //    console.log(user.userId);

    console.log('AxUserRegisterDialog showDialog pre');
    this.showDialog({
      type: 'AxUserRegisterDialog',
      props: {
        callback,
        user
      }
    });
  }

  ClickOpenGroupPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    const listAllGroup = this.pageInfo?.listGroup;
    if (!listAllGroup) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 그룹 선택',
      param: {
        items: listAllGroup,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorData[];
          const remain = this.state.listGroup;

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listGroup = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickOpenGroupBatch() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    this.batchDialogState.listGroup = [];
    this.batchDialogState.selectGroup = '';

    const listAllGroup = this.pageInfo?.listGroup.filter(
      x => x.zoneCode === this.batchDialogState.groupzoneCode
    );
    if (!listAllGroup) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 그룹 선택',
      param: {
        items: listAllGroup,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorData[];

          this.batchDialogState.listGroup = selected;
          this.batchDialogState.selectGroup = selected.length.toString() + '개 선택';
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickOpenDoorPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    const listAllDoor = this.pageInfo?.listDoor.filter(
      x => x.zoneCode === this.batchDialogState.doorzoneCode
    );
    if (!listAllDoor) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 선택',
      param: {
        items: listAllDoor,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorData[];
          const remain = this.state.listDoor;

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listDoor = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickOpenDoorBatch() {
    type GroupPrivParams = { title: string; param: I.DataParam };
    this.batchDialogState.listDoor = [];
    this.batchDialogState.selectDoor = '';

    const listAllDoor = this.pageInfo?.listDoor.filter(
      x => x.zoneCode === this.batchDialogState.doorzoneCode
    );
    if (!listAllDoor) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 선택',
      param: {
        items: listAllDoor,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorData[];

          this.batchDialogState.listDoor = selected;
          this.batchDialogState.selectDoor = selected.length.toString() + '개 선택';
        }
      }
    });
    this.showDialog(dialogParams);
  }

  async onClearAdvSearch() {
    const result = await this.showConfirmModal('확인', '고급 검색 필터를 초기화할까요?', [
      '네',
      '아니오'
    ]);
    if (result === 0) {
      this.state = new State();
    }
  }

  async onExportExcelConfirm(prefix: string) {
    if (!this.searchData) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const result = await this.showConfirmModal(
      '확인',
      '검색한 데이터들을 엑셀로 내보냅니다<br />계속하시겠습니까?',
      ['네', '아니오']
    );
    if (result === 0) {
      this.setLoading(true);
      // setTimeout(() => this.onExportExcel(prefix), 500);
    }
  }

  openCodeSelectDialog(title: string, name: string) {
    console.log('pageinfo', this.pageInfo);
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = ((this.pageInfo as unknown) as { [name: string]: I.CodeData[] })[name];
    console.log('items', items);
    const selected = ((this.state as unknown) as {
      [name: string]: I.CodeData[];
    })[name];
    console.log('selected', selected);
    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      ((this.state as unknown) as { [name: string]: I.CodeData[] })[name] = selected.sort((a, b) =>
        a.code.localeCompare(b.code)
      );
    };
    console.log('callback', callback);
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openCodeSelectDialogSingle(title: string, listCodeName: string, codeName: string) {
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = ((this.batchDialogState as unknown) as { [listCodeName: string]: I.CodeData[] })[
      listCodeName
    ];
    const selected = ((this.batchDialogState as unknown) as {
      [codeName: string]: I.CodeData;
    })[codeName];

    const listSelected: I.CodeData[] = [];
    listSelected.push(selected);

    console.log('item');
    console.log(items);

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      const item = selected[0];
      ((this.batchDialogState as unknown) as { [codeName: string]: I.CodeData })[codeName] = item;
      console.log('batchDialogState');
      console.log(this.batchDialogState);
    };
    console.log('selected');
    console.log(listSelected);

    this.dialogState.show = true;
    this.dialogState.singleSelect = true;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = listSelected as never;
    this.dialogState.callback = callback;
  }

  openSelectDialog(
    title: string,
    headers: unknown[],
    items: unknown[],
    selected: unknown[],
    callback: () => Promise<void>
  ) {
    console.log('open dialog');
    console.log(callback);
    this.dialogState.show = true;
    this.dialogState.singleSelect = false;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = selected as never;
    this.dialogState.callback = callback;
  }

  onDialogChanged() {
    this.dialogState.callback();
  }

  onDialogRowClicked(item: never) {
    if (this.dialogState.singleSelect) {
      this.dialogState.selected = [];
      this.dialogState.selected.push(item);
    } else {
      const idx = this.dialogState.selected.findIndex(x => x === item);
      if (idx > -1) {
        this.dialogState.selected.splice(idx, 1);
      } else {
        this.dialogState.selected.push(item);
      }
    }
  }
  // 그리드 클릭 이벤트

  OnClickSearchRow(item: never) {
    // const idx = this.state.selected.findIndex(x => x === item);
    // if (idx > -1) {
    //   this.state.selected.splice(idx, 1);
    // } else {
    //   this.state.selected.push(item);
    // }
    console.log('rowclicked');
    const callback = async (user: I.User) => {
      this.closeDialog();
      const f = this.searchData.listUser.find(x => x.userId === user.userId);
      if (f) {
        const idx = this.searchData.listUser.indexOf(f);
        this.searchData.listUser.splice(idx, 1, user);
      }
    };

    const user = item;
    this.showDialog({
      type: 'AxUserRegisterDialog',
      props: {
        callback,
        user
      }
    });
  }

  OnDbClickSearchRow(event: never, item: never) {
    console.log('더블클릭');
    this.ClickUserEdit();
  }

  async OnClickBatchUpdate() {
    await this.batchDialogState.callback();
    if (this.batchDialogState.periodFrom !== null) {
      this.batchDialogState.periodFrom = `${this.batchDialogState.periodTo}T00:00:00.000Z`;
    }
    if (this.batchDialogState.periodTo !== null) {
      this.batchDialogState.periodTo = `${this.batchDialogState.periodTo}T23:59:00.000Z`;
    }
    console.log('batch', this.batchDialogState);
    const {
      companyCode,
      deptCodeA,
      deptCodeB,
      dutyCodeA,
      userStatus,
      periodFrom,
      periodTo,
      listGroup,
      listDoor,
      groupFlag,
      doorFlag
    } = this.batchDialogState;
    const req: I.PacketUserBatchUpdate = {
      listUpdateUser: (this.state.selected as I.User[]).map(x => x.userId),
      companyCode: companyCode.code,
      deptCodeA: deptCodeA.code,
      deptCodeB: deptCodeB.code,
      dutyCodeA: dutyCodeA.code,
      userStatus: userStatus.code,
      periodFrom: periodFrom,
      periodTo: periodTo,
      listGroup: listGroup,
      listDoor: listDoor,
      groupFlag: groupFlag,
      doorFlag: doorFlag
    };
    console.log('req', req);
    const result = await this.API.call.user.userBatchUpdate(req);
    if (result instanceof Error) {
      await await this.showErrorModal('알림', result.message);
      return false;
    } else {
      this.RespBatchUpdate(result.data);
      await this.showErrorModal('알림', '일괄 수정 되었습니다.');
      this.batchDialogState.show = false;
    }
  }

  async OnClose() {
    this.batchDialogState.show = false;
  }

  async OnClearClicked() {
    this.batchDialogState.companyCode.code = '';
    this.batchDialogState.companyCode.name = '';
    this.batchDialogState.deptCodeA.code = '';
    this.batchDialogState.deptCodeA.name = '';
    this.batchDialogState.deptCodeB.code = '';
    this.batchDialogState.deptCodeB.name = '';
    this.batchDialogState.dutyCodeA.code = '';
    this.batchDialogState.dutyCodeA.name = '';
    this.batchDialogState.userStatus.code = '';
    this.batchDialogState.userStatus.name = '';
    this.batchDialogState.selectGroup = '';
    this.batchDialogState.selectDoor = '';
    this.batchDialogState.periodFrom = null;
    this.batchDialogState.periodTo = null;
  }

  RespBatchUpdate(listUser: I.User[]) {
    console.log(listUser);
    const list = this.searchData.listUser;
    listUser.forEach(user => {
      const find = list.find(x => x.userId === user.userId);
      if (find) {
        list.splice(list.indexOf(find), 1, user);
      }
    });
  }

  async closeDialog() {
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
    }, 100);
  }

  async onSearchClicked() {
    this.state.pageNum = 1;
    this.isGridOnOff = false;
    this.onSelectedClear(); //선택내역 초기화
    this.setLoading(true);
    if (this.isOpenAdvSearch) await this.requestSearchDetail();
    else await this.requestSearch();
    this.setLoading(false);
  }

  async onPageChanged(pageNum: number) {
    this.state.pageNum = pageNum;
    this.selected.forEach(item => {
      item.select = false;
    });
    this.state.selected = [];
    await this.requestSearchDetail();
  }

  async onSelectedClear() {
    this.selected.forEach(item => {
      item.select = false;
    });
    this.state.selected = [];
  }

  async onPreviousPageClicked() {
    this.state.pageNum = this.previousPageGroup;
    await this.requestSearchDetail();
  }

  async onNextPageClicked() {
    this.state.pageNum = this.nextPageGroup;
    await this.requestSearchDetail();
  }

  async onGridChanged(Grid: boolean) {
    this.state.pageNum = 1;
    console.log('on click this.state.isSearchGrid=' + Grid);
    console.log('on click this.state.isSearchGrid=' + this.state.isSearchGrid);
    this.state.isSearchGrid = !Grid;
    await this.requestSearchDetail();
  }

  async onSearchClickedOn() {
    if (this.isGridOnOff) {
      this.state.pageNum = 1;
      console.log('onSearchClickedOn');
      this.state.isSearchGrid = true;
      if (this.isOpenAdvSearch) await this.requestSearchDetail();
      else await this.requestSearch();
      this.isGridOnOff = false;
    } else {
      this.isGridOnOff = true;
    }
    console.log('onSearchClickedOn xxx=' + this.isGridOnOff);
  }
  async onSearchClickedOff() {
    if (this.isGridOnOff) {
      this.state.pageNum = 1;
      console.log('onSearchClickedOff');
      this.state.isSearchGrid = false;
      if (this.isOpenAdvSearch) await this.requestSearchDetail();
      else await this.requestSearch();
      this.isGridOnOff = false;
    } else {
      this.isGridOnOff = true;
    }
    console.log('onSearchClickedOff xxx=' + this.isGridOnOff);
  }

  get searchIndicate() {
    if (!this.searchData) return;

    const searchCount = this.searchData.searchCount || 0;

    const pageCount = this.searchData.pageCount || 0;
    const pageNum = this.searchData.pageNum || 0;
    if (!this.state.isSearchGrid) {
      return `총 ${searchCount}건`;
    }
    return `총 ${searchCount}건. 페이지 ${pageNum} / ${pageCount}`;
  }

  get previousPageGroup() {
    if (this.startPageGroup === 1) {
      return this.startPageGroup;
    }

    return this.startPageGroup - this.showPageCount;
  }

  get nextPageGroup() {
    const pageCount = this.searchData.pageCount || 1;

    if (this.startPageGroup + this.showPageCount > pageCount) {
      return this.startPageGroup + this.availablePageCount - 1;
    }

    return this.startPageGroup + this.showPageCount;
  }

  get startPageGroup() {
    const pageNum = this.searchData.pageNum || 1;
    const showPageCount = this.showPageCount;

    const calc = Math.floor((pageNum - 1) / showPageCount) * showPageCount;

    return calc + 1;
  }

  get availablePageCount() {
    const pageCount = this.searchData.pageCount || 1; //14
    const showPageCount = this.showPageCount; //5
    if (pageCount < showPageCount) {
      return pageCount;
    } else {
      return this.startPageGroup + 4 >= pageCount ? pageCount - this.startPageGroup + 1 : 5;
    }
  }

  get pageList() {
    return this.generateArray(this.startPageGroup, this.availablePageCount);
  }

  submit() {
    alert('submit');
  }
}
